import i18n from '../../utils/i18n'

export default [
  {
    title: i18n.t('usermenu5'), // '交易系统'
    isOpen: false,
    isShow: true,
    icon: 'trade',
    externalAction: 'tradeSystem'
  },
  {
    title: i18n.t('my3'), // '我的资金'
    isOpen: false,
    isShow: true,
    icon: 'fund',
    navChild: [
      {
        title: i18n.t('index5'), // '入金'
        isShow: true,
        name: 'publicDeposit'
      },
      {
        title: i18n.t('index7'), // '转账'
        isShow: true,
        name: 'userTransfer'
      },
      {
        title: i18n.t('index8'), // '钱包'
        isShow: true,
        name: 'userWallet'
      },
      {
        title: i18n.t('index6'), // '出金'
        isShow: true,
        name: 'publicWithdrawal'
      },
      {
        title: i18n.t('usermenu1'), // '风险补偿赠金'
        isShow: true,
        name: 'forexBonus'
      },
      {
        title: i18n.t('usermenu2'), // '每日成长赠金'
        isShow: true,
        name: 'miningRewards'
      }
    ]
  },
  {
    title: i18n.t('userstatement3'), // 报表管理
    isOpen: false,
    isShow: true,
    icon: 'audit',
    navChild: [
      {
        title: i18n.t('my5'), // '入金记录'
        isShow: true,
        name: 'publicDepositRecord'
      },
      {
        title: i18n.t('my45'), // '出金记录'
        isShow: true,
        name: 'publicWithdrawalRecord'
      },
      {
        title: i18n.t('usermenu3'), // '账户划转记录'
        isShow: true,
        name: 'userTransferRecord'
      },
      {
        title: i18n.t('usermenu4'), // '账户转账记录'
        isShow: true,
        name: 'userAgentTransfer'
      },
      {
        title: i18n.t('userstatement92'), // 日内交易记录
        isShow: true,
        name: 'userDayTrade'
      },
      {
        title: i18n.t('fundstreams1'),
        isShow: true,
        name: 'userFundStreams'
      }
    ]
  },
  {
    title: i18n.t('promotionCenter'),
    isOpen: false,
    isShow: true,
    icon: 'sub',
    navChild: [
      {
        title: i18n.t('promotionCenter'),
        isShow: true,
        name: 'userPromotionCenter'
      },
      {
        title: i18n.t('invitationDetailsV2'),
        isShow: true,
        name: 'userInvitationDetail'
      },
      {
        title: i18n.t('commissionDetailsV2'),
        isShow: true,
        name: 'userCommissionDetailsNew'
      },
      {
        title: i18n.t('membershipCenter'),
        isShow: true,
        name: 'userMembershipCenter'
      }
    ]
  },
  {
    title: i18n.t('index20'), // '个人信息'
    isOpen: false,
    isShow: true,
    icon: 'my',
    name: 'userInfo'
  },
  {
    title: i18n.t('user87'), // 'Notifications'
    name: 'message',
    isOpen: false,
    isShow: true,
    icon: 'not'
  }
]
